import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Toggle from '@/components/General/inputs/Toggle';
import DatePickerInput from '@/components/General/inputs/DatePickerInput';
import SolidButton from '@/components/General/SolidButton';
import Unicon from '@/components/General/Unicon';

const FREQUENCIES = ['WEEKLY', 'BIWEEKLY', 'MONTHLY', 'QUARTERLY', 'YEARLY'];

export default function RecurringGiftToggle({ value = { isRecurring: false, frequency: 'MONTHLY', startDate: new Date() }, onChange, onManage, testID = 'recurring-gift-toggle' }) {
    const { isRecurring, frequency, startDate } = value;

    const update = (updates) => onChange?.({ ...value, ...updates });

    return (
        <View style={styles.container} testID={testID}>
            <View style={styles.headerRow}>
                <Text style={styles.title}>Make this a recurring gift</Text>
                {onManage && (
                    <Pressable testID={`${testID}-manage`} onPress={onManage} style={styles.manageBtn}>
                        <Unicon name="create-outline" size={16} colorVariant="textSecondary" />
                        <Text style={styles.manageText}>Manage</Text>
                    </Pressable>
                )}
            </View>
            <View style={styles.row}>
                <Text style={styles.subtitle}>Schedule automatic gifts going forward.</Text>
                <View testID={`${testID}-switch`}>
                    <Toggle
                        value={isRecurring}
                        onValueChange={(next) => update({ isRecurring: next })}
                    />
                </View>
            </View>
            {isRecurring && (
                <View style={styles.details} testID={`${testID}-details`}>
                    <Text style={styles.label}>Frequency</Text>
                    <View style={styles.frequencyRow}>
                        {FREQUENCIES.map((freq) => (
                            <SolidButton
                                key={freq}
                                testID={`${testID}-frequency-${freq}`}
                                text={freq[0] + freq.slice(1).toLowerCase()}
                                size="sm"
                                variant={frequency === freq ? 'normal' : 'outlined'}
                                type="giving"
                                onPress={() => update({ frequency: freq })}
                            />
                        ))}
                    </View>
                    <DatePickerInput
                        testID={`${testID}-start-date`}
                        title="Start date"
                        value={startDate}
                        onUpdate={(date) => update({ startDate: date })}
                        minimumDate={new Date()}
                        mode="date"
                    />
                </View>
            )}
        </View>
    );
}

const styles = StyleSheet.create(({ colors, fonts, spacing, roundness, shadows, typography }) => ({
    container: {
        gap: spacing.sm,
        padding: spacing.md,
        borderRadius: roundness.md,
        backgroundColor: colors.surface,
        boxShadow: shadows.card,
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    manageBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        padding: spacing.xs,
    },
    manageText: {
        fontSize: typography.caption,
        fontFamily: fonts.body,
        color: colors.textSecondary,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: spacing.sm,
    },
    title: {
        fontSize: typography.h3,
        fontFamily: fonts.heading,
        color: colors.text,
    },
    subtitle: {
        fontSize: typography.caption,
        fontFamily: fonts.body,
        color: colors.textSecondary,
    },
    details: {
        gap: spacing.md,
        paddingTop: spacing.sm,
    },
    label: {
        fontSize: typography.caption,
        fontFamily: fonts.heading,
        color: colors.textSecondary,
        textTransform: 'uppercase',
    },
    frequencyRow: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: spacing.sm,
    },
}));
